module.exports = __webpack_public_path__ + "img/garçon.84c691be.jpg";